import { WorkflowFilterStatus } from '@app/shared/types/sf-data'

export const determineFilterValue = ({
  allowedFilterValues,
  defaultFilterValue,
  incomingFilter,
}: {
  allowedFilterValues: WorkflowFilterStatus[]
  defaultFilterValue: WorkflowFilterStatus
  incomingFilter: WorkflowFilterStatus
}): WorkflowFilterStatus => {
  if (!incomingFilter || !allowedFilterValues.includes(incomingFilter)) {
    return defaultFilterValue
  }

  // Different screens might have different interpretations of the 'show-all' filter
  if (incomingFilter === 'show-all') {
    return defaultFilterValue
  }

  return incomingFilter
}
